import { render } from "./Inquiry.vue?vue&type=template&id=730dddf6&scoped=true"
import script from "./Inquiry.vue?vue&type=script&lang=js"
export * from "./Inquiry.vue?vue&type=script&lang=js"

import "./Inquiry.vue?vue&type=style&index=0&id=730dddf6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-730dddf6"

export default script